import { useEffect } from 'react';

import { useCurrentApplication } from '@hook/application/use-current-application.hook';
import { useLazyLoadPaymentsQuery } from '@hook/billing/billing.hooks';
import { isString } from '@util/data/is-exist';

export const usePaymentHistory = () => {
  const { current } = useCurrentApplication();
  const [load, { isLoading, data }] = useLazyLoadPaymentsQuery();

  useEffect(() => void (isString(current.id) && load(current.account.id).unwrap()), [current.id]);

  return { data: data?.data ?? [], isLoading };
};
